import React, { useEffect } from 'react';
import { FaChevronLeft, FaChevronRight, FaTimes } from 'react-icons/fa';

// Full-screen image viewer with keyboard navigation.
const MediaLightbox = ({ images, index, onChange, onClose }) => {
    useEffect(() => {
        const onKey = (e) => {
            if (e.key === 'Escape') onClose();
            if (e.key === 'ArrowLeft') onChange((index + 1) % images.length);
            if (e.key === 'ArrowRight') onChange((index - 1 + images.length) % images.length);
        };
        window.addEventListener('keydown', onKey);
        return () => window.removeEventListener('keydown', onKey);
    }, [images.length, index, onChange, onClose]);

    if (index === null || !images[index]) return null;

    return (
        <div className="media-lightbox" onClick={onClose}>
            <button type="button" className="lightbox-close" onClick={onClose} aria-label="إغلاق"><FaTimes /></button>
            {images.length > 1 && (
                <button type="button" className="lightbox-nav next" aria-label="التالي" onClick={(e) => { e.stopPropagation(); onChange((index + 1) % images.length); }}>
                    <FaChevronLeft />
                </button>
            )}
            <img src={images[index]} alt="" onClick={(e) => e.stopPropagation()} />
            {images.length > 1 && (
                <button type="button" className="lightbox-nav prev" aria-label="السابق" onClick={(e) => { e.stopPropagation(); onChange((index - 1 + images.length) % images.length); }}>
                    <FaChevronRight />
                </button>
            )}
            <div className="lightbox-counter">{index + 1} / {images.length}</div>
        </div>
    );
};

export default MediaLightbox;
